import { useMutation } from '@apollo/client';
import { UpdateProductDistributionInput, UpdateProductDistributionMutationVariables } from '_graphql/mutation/__generated__/graphql';
import { UPDATE_PRODUCT_DISTRIBUTION } from '_graphql/mutation/products';

export const useUpdateProductDistribution = (
  variables?: UpdateProductDistributionMutationVariables
) => {
  const [updateProductDistribution, { ...rest }] = useMutation<
    UpdateProductDistributionInput,
    UpdateProductDistributionMutationVariables
  >(UPDATE_PRODUCT_DISTRIBUTION, {
    variables,
    refetchQueries: ['GetProduct'],
  });
  return {
    ...rest,
    updateProductDistribution,
  };
};
